<template>
    <div class="page">

        <!--这里的state传end是因为这个页面要求的banner样式和end一致，并非试用真的结束-->
        <banner :food_img="food_img" state="end"/>

        <!--产品信息BEGIN-->
        <applyStateComponent :stage="stage" :title="title" :try_subtitle="try_subtitle" :nextText="nextText"
                             :nextStyle="nextStyle" :nextTid="nextTid" v-if="title"/>
        <!--产品信息END-->

        <div class="container">
            <div class="containerMiddle">

                <!--用户信息BEGIN-->
                <div class="userInfo">
                    <div class="userDetail">
                        <div class="tx">
                            <img class="portrait" v-if="init" :src="avatar"/>
                        </div>

                        <div class="name">
                            {{ nickname }}
                        </div>
                    </div>
                    <bannerCountdown class="countdown"></bannerCountdown>
                </div>
                <!--用户信息EDN-->


                <div class="content center">
                    <div class="row">
                        <btnGroup v-if="loaded"/>
                    </div>
                </div>

                <div class="content">
                    <div class="row">
                        <h3>等你来赞</h3>
                    </div>

                    <likeList v-if="init" :likeList="likeList"/>

                    <div class="row">
                        <h4>已有{{ likeTotal }}个赞，快来为ta点赞吧</h4>
                    </div>
                </div>

                <div class="content">
                    <h3>活动规则</h3>
                    <div class="detail_info" v-html="rule"></div>
                </div>
            </div>
        </div>

        <div v-show="showShare" @touchmove.prevent @click="hideShare" class="share">
            <img src="static/share.png" class="shareImg"/>
        </div>
    </div>
</template>

<script>
    // import countdown from "@/components/Countdown.vue";
    import bannerCountdown from "@/components/banner-countdown.vue";
    import likeList from "@/components/likeList.vue";
    import banner from "@/components/banner.vue";
    import btnGroup from "@/components/btnGroup.vue";
    import applyStateComponent from "@/components/apply-state.vue";
    import {EventBus} from "../event-bus.js";
    import {mapState} from "vuex";

    export default {
        name: "page1",
        data() {
            return {
                food_img: '',
                nickname: "",
                avatar: "",
                likeList: "",
                rule: "",
                stage: "",
                title: "",
                try_subtitle: "",
                price: "",
                state: "a",
                likeTotal: 0,
                nextTid: 0,
                nextStyle: '',
                nextText: '',
                pageRecord: {
                    module:'eshop促销活动',
                    category1: '0元试用',
                    title: '0元试用'
                }
            };
        },
        created() {
            var storage = window.localStorage;
            var likedMap = JSON.parse(storage.getItem("likedMap") || "{}");
            console.log(["likedMap", likedMap]);

            //如果已经喜欢了
            if (likedMap["liked" + this.$route.params.id]) {
                this.$store.commit("setState", {
                    liked: true,
                });
            }

            this.getReplylist();

            EventBus.$on("updateList", ({}) => {
                this.getReplylist();
            });

            //获取本地存储已经喜欢的aid
            this.axios
                .get(
                    "/campaigns-b/try/index.php?_c=show&_a=get&aid=" + this.$route.params.id
                )
                .then((response) => {
                    // console.log(response)
                    var d = response.data.data;

                    this.nickname = d.nickname;
                    this.avatar = d.avatar;
                    this.food_img = d.detail.banner_pic
                    //this.likeList = d.replylist;
                    this.rule = d.detail.show_rule_pc;
                    this.stage = d.detail.try_stage;
                    this.title = d.detail.try_title;
                    this.try_subtitle = d.detail.try_subtitle;

                    if (d.detail.next) {
                        this.nextTid = d.detail.next.id;
                        this.nextText = d.detail.next.try_stage;
                        this.nextStyle = '';
                    } else {
                        this.nextTid = '';
                        this.nextText = '';
                        this.nextStyle = 'background: url(./images/detail-product-title-bg.png) top center/cover no-repeat;background-size: 100% 100%;';
                    }
                    this.$store.commit("init", {
                        startTime: new Date(d.detail.date_begin.replace(/-/g, "/")).getTime(),
                        endTime: new Date(d.detail.date_end.replace(/-/g, "/")).getTime(),
                        price: d.detail.try_price,
                        aid: this.$route.params.id,
                        uid: d.uid,
                        detailId: d.detail.id,
                        try_chou: d.detail.try_chou,
                        stage: this.stage,
                        tid: d.try_id,
                        applyNum: d.detail.applytotal,
                        totalNum: d.detail.total,
                    });

                    //this.init = true;
                    config.routerCallback(Object.assign({}, d, {
                        pageName: "show",
                        debug: process.env.VUE_APP_FLAG !== "pro"
                    }));
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error);
                });
            this.pageRecord.category2 = this.uid === this.userInfoId ? '试用分享' : '好友点赞';
            this.gioPageAction(this.pageRecord);
        },
        computed: {
            loaded() {
                console.log(["init", this.uid, this.userInfoId]);
                if (!this.$store.state.authed) {
                    if (this.uid) {
                        //if(this.uid != this.userInfoId){
                        return true;
                        //}
                    }
                } else {
                    //如果已经授权就等待两个变量都有值
                    if (this.uid && this.userInfoId) {
                        //if(this.uid != this.userInfoId){
                        return true;
                        //}
                    }
                }

                return false;
            },
            ...mapState([
                "init",
                /*
                        'activityRule',
                        'liked',
                        'userName',
                        'userPortrait',
                        'newPrice',
                        'stage',*/
                "applyState",
                "userInfo",
                "uid",
                "showShare",
                "userInfoId",
            ]),
        },
        methods: {
            hideShare() {
                this.$store.commit("setState", {
                    showShare: false,
                });
            },
            getReplylist() {
                this.axios.get("/campaigns-b/try/index.php?_c=show&_a=getReplylist&aid=" + this.$route.params.id)
                    .then((response) => {
                        console.log(response);
                        var d = response.data.data;
                        // 为没有头像的用户设置默认头像
                        this.likeList = d.rows.map(item => ({
                            ...item,
                            avatar: item.avatar || 'https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/try/try-default.png'
                        }));
                        this.likeTotal = d.total;
                    })
                    .catch(function (error) {
                        // 请求失败处理
                        console.log(error);
                    });
            },
        },
        components: {
            // countdown,
            likeList,
            banner,
            btnGroup,
            applyStateComponent,
            bannerCountdown
        },
        beforeDestroy() {
            this.$store.commit("setState", {
                liked: false,
            });
        },
    };
</script>

<style scoped lang="scss">
    .page{
        padding-bottom: .1rem;
    }
    .container {
        position: relative;
        margin: 0 auto;
        overflow: hidden;
        width: 7.22rem;
        padding: .1rem;
        background: #d2e8ff;
        border-radius: .1rem;
    }


    .userDetail {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }


    .containerMiddle {
        border: 1px dashed #1C5CDC;
        padding: .3rem;
        border-radius: .1rem;

        .content {
            h3 {
                color: #000;
                font-size: .24rem;
            }

            h4 {
                color: #000;
                font-size: .22rem;
            }

            .detail_info {
                padding-top: .3rem;
                color: #000;
                font-size: .18rem;
            }
        }
    }

    .countdown {
        height: 1.169642rem;
        display: flex;
        justify-content: center;

        ::v-deep .text {
            color: #1f3b57;
            font-size: .24rem;
            font-weight: bold;
            padding-right: .2rem;
        }

        ::v-deep.cutdown_left_time {
            /*width: 2.5rem;*/
            color: #1f3b57;
            border: 1px solid #1f3b57;
            font-size: .24rem;

            li:first-child span {
                border-right: 1px dashed #1f3b57;
            }
        }
    }

    .share {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 103;
        background: rgba(0, 0, 0, 0.59);
    }

    .share .shareImg {
        display: block;
        margin: 11.2vw auto 0;
        width: 75%;
    }

    .share .qrCodeImg {
        width: 30%;
        position: fixed;
        top: 14rem;
        left: 50%;
        margin-left: -15%;
    }

</style>
